/**
 * @description Поиск текстового поля.
 * @param {any} el Элемент.
 * @returns {HTMLInputElement}
 */
const queryInputElementInside = (el) => (
  el instanceof HTMLInputElement
    ? el
    : el.querySelector('input, textarea') || el
);

/**
 * @description Директива установки первого символа в верхний регистр.
 * @returns {any}
 */
export default {
  updated(el) {
    const element = queryInputElementInside(el);
    const text = element.value;
    const firstChar = text.charAt(0);
    if (text && firstChar !== firstChar.toUpperCase()) {
      element.value = firstChar.toUpperCase() + text.slice(1);
      element.dispatchEvent(new CustomEvent('input'));
    }
  },
};
